import { cache, stashCache } from 'src/feathers/hooks';
import { yup } from 'straightline-utils/validation';

const validateQuery = async (context) => {
  const schema = yup.object({
    departure_time: yup.string().trim().label('Departure Time'),
    pickup_address: yup.object({
      latitude: yup.number().latitude().label('Latitude').required(),
      longitude: yup.number().longitude().label('Longitude').required(),
      country: yup.string().trim().label('Country').required(),
      state: yup.string().trim().label('State').required()
    }),
    delivery_address: yup.object({
      latitude: yup.number().latitude().label('Latitude').required(),
      longitude: yup.number().longitude().label('Longitude').required(),
      country: yup.string().trim().label('Country').required(),
      state: yup.string().trim().label('State').required()
    })
  });
  context.params.query = await schema.validateQuery(context.params.query);
  return context;
};

// https://gis.stackexchange.com/questions/15197/google-maps-v3-in-javascript-api-render-route-obtained-with-web-api
const parseDirections = async (context) => {
  context.result.directions = await context.service.parseDirections(
    context.result
  );
  return context;
};

export default {
  before: {
    find: [validateQuery, cache]
  },

  after: {
    find: [parseDirections, cache, stashCache()]
  },

  error: {
    find: []
  }
};
